import type { PostLikesData } from '@/types';
import { LikeButton } from '@/ui/LikeButton';
import { TooltipWrapper } from '@/ui/TooltipWrapper';

import * as styles from '../PostActions.css';

type LikeActionButtonProps = {
  data: PostLikesData;
  translations?: Record<string, string>;
};

export const LikeActionButton = ({ data, translations, ...props }: LikeActionButtonProps) => {
  if (translations?.['search.pagination.like']) {
    return (
      <TooltipWrapper portalId="post-actions-container" tooltipText={translations['search.pagination.like']}>
        <LikeButton data={data} styles={styles} buttonType="submit" {...props} />
      </TooltipWrapper>
    );
  }

  return <LikeButton data={data} styles={styles} buttonType="submit" onClick={undefined} />;
};
